<nz-spin [nzSpinning]="this.loading">
  <div *ngIf="country" class="grid grid-cols-1 mb-3">
    <div>
      <label
        class="mb-1"
        nz-checkbox
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="currentCountryBoxChecked"
        (ngModelChange)="onChangeCurrentCountry($event)"
      >{{ 'itineraries.accommodation.form.displayAccommodationsOnlyFrom' | transloco }} {{ this.country }}</label>
    </div>
  </div>
<div class="grid grid-cols-1">
  <div>
    <nz-select
      #searchBar
      nzShowSearch
      nzServerSearch
      [nzPlaceHolder]="'itineraries.accommodation.form.searchAccommodation' | transloco"
      [(ngModel)]="selectedAccommodate"
      [nzShowArrow]="false"
      (nzOnSearch)="searchHotel($event)"
      (ngModelChange)="selectedAccommodation(selectedAccommodate)"
    >
      <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.placePrediction.text.text"
                 [nzValue]="option.placePrediction"></nz-option>
    </nz-select>
  </div>
</div>
<!--  <ng-container *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT && this.selectedAccommodate === undefined">-->
<!--    <h5 class="mt-5">Selected Accommodation : {{this.tempAccommodationName}}</h5>-->
<!--  </ng-container>-->
<nz-divider></nz-divider>
<div *ngIf="this.isHotelSelected" class="grid grid-cols-12 gap-5">
  <div class="col-span-6">
    <img class="w-full h-80 object-cover rounded-md" [src]="getSelectedImage()"
         alt=""/>
  </div>
  <div class="col-span-6">
    <nz-radio-group
      class="flex justify-items-center"
      nzButtonStyle="solid"
      [(ngModel)]="this.imageUri">
      <label
        class="w-16 h-16 md:w-24 md:h-24 p-1 mb-3 mr-3"
        *ngFor="let img of imageURLS"
        nz-radio-button
        [nzValue]="img">
        <img
          class="w-full h-full object-cover"
          [src]="img"
          alt=""/>
      </label>
    </nz-radio-group>
    <div class="flex justify-center">
      <nz-upload
        [(nzFileList)]="fileList"
        [nzShowButton]="fileList.length < 8"
        [nzCustomRequest]="customUploadReq"
        (nzChange)="handleChange($event)"
        nzAccept="image/png,image/jpg,image/jpeg"
        [nzHeaders]="setMediaUploadHeaders"
        [nzRemove]="onRemove"
        [nzShowUploadList]="false">
        <div class="mt-3">
          <p>
            <span class="me-2" nz-icon nzType="upload"></span>
            <a>{{ 'itineraries.accommodation.form.clickToUploadMore' | transloco }}</a>
          </p>
        </div>
      </nz-upload>
    </div>

  </div>
</div>
<nz-divider></nz-divider>
<div class="grid grid-cols-1">
  <div class="mt-4">
    <form nzLayout="vertical" nz-form [formGroup]="accommodationForm">
      <div class="grid grid-cols-2 gap-5">
        <div *ngIf="!this.itinerary.tour.isDatesOptional">
          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="checkIn"
            >{{ 'itineraries.accommodation.form.checkIn' | transloco }}
            </nz-form-label
            >
            <nz-form-control [nzErrorTip]='checkInCheck'>
              <nz-date-picker [nzDefaultPickerValue]="this.itinerary.tour.startDate"
                              [nzDisabledDate]="disabledDateCheckIn"
                              formControlName="checkIn"></nz-date-picker>
            </nz-form-control>
            <ng-template #checkInCheck>
            <span *ngIf="formErrors.checkIn.required">
              {{ 'itineraries.accommodation.form.errors.checkInRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>
        </div>
        <div *ngIf="this.itinerary.tour.isDatesOptional">
          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="checkIn"
            >{{ 'itineraries.accommodation.form.checkIn' | transloco }}
            </nz-form-label
            >
            <nz-form-control [nzErrorTip]='checkInCheck'>
              <nz-select
                formControlName="checkIn"
                [nzPlaceHolder]="'itineraries.accommodation.form.selectCheckInDate' | transloco"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let option of dateCheckInOptions"
                  [nzValue]="option.value"
                  [nzLabel]="option.label"
                  [nzDisabled]="option.disabled">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #checkInCheck>
                    <span *ngIf="formErrors.checkIn.required">
                      {{ 'itineraries.accommodation.form.errors.checkInRequired' | transloco }}
                    </span>
            </ng-template>
          </nz-form-item>
        </div>
        <div *ngIf="!this.itinerary.tour.isDatesOptional">
          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="checkOut"
            >{{ 'itineraries.accommodation.form.checkOut' | transloco }}
            </nz-form-label
            >
            <nz-form-control [nzErrorTip]='checkOutCheck'>
              <nz-date-picker [nzDefaultPickerValue]="this.itinerary.tour.startDate"
                              [nzDisabledDate]="disabledDateCheckOut"
                              formControlName="checkOut"></nz-date-picker>
            </nz-form-control>
            <ng-template #checkOutCheck>
            <span *ngIf="formErrors.checkOut.required">
              {{ 'itineraries.accommodation.form.errors.checkOutRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>
        </div>
        <div *ngIf="this.itinerary.tour.isDatesOptional">
          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="checkOut"
            >{{ 'itineraries.accommodation.form.checkOut' | transloco }}
            </nz-form-label
            >
            <nz-form-control [nzErrorTip]='checkOutCheck'>
              <nz-select
                formControlName="checkOut"
                [nzPlaceHolder]="'itineraries.accommodation.form.selectCheckOutDate' | transloco"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let option of dateCheckOutOptions"
                  [nzValue]="option.value"
                  [nzLabel]="option.label"
                  [nzDisabled]="option.disabled">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #checkOutCheck>
            <span *ngIf="formErrors.checkOut.required">
              {{ 'itineraries.accommodation.form.errors.checkOutRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>
        </div>
      </div>
      <div class="grid grid-cols-2 mt-2 gap-5">
        <div>
          <nz-form-item>
            <nz-form-label nzFor="websiteUri"
            >{{ 'itineraries.accommodation.form.websiteLink' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="websiteUriCheck">
              <input
                type="text"
                nz-input
                formControlName="websiteUri"
                [placeholder]="'itineraries.accommodation.form.enterWebsiteLink' | transloco"/>
            </nz-form-control>
            <ng-template #websiteUriCheck>
              <span *ngIf="formErrors.websiteUri.required">{{ 'itineraries.accommodation.form.errors.websiteLinkRequired' | transloco }}</span>
              <span *ngIf="formErrors.websiteUri.pattern">{{ 'itineraries.accommodation.form.errors.validUrlRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="flex justify-start">
            <nz-form-label nzFor="rating">
              {{ 'itineraries.accommodation.form.starRating' | transloco }}
            </nz-form-label>
            <nz-form-control>
              <nz-rate class="custom-rate" [nzCount]="7"  nzAllowHalf formControlName="rating"></nz-rate>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label nzFor="notes">{{ 'itineraries.accommodation.form.hotelDescription' | transloco }}</nz-form-label>
            <nz-form-control>
                  <textarea
                    [placeholder]="'itineraries.accommodation.form.hotelDescription' | transloco"
                    nz-input
                    formControlName="hotelDescription"
                    rows="6"></textarea>
            </nz-form-control>
          </nz-form-item>
          <div class="flex justify-end">
            <button class="ai-button flex items-center" nz-button nzType="default"
                    [disabled]="this.itinerary.tour.language === 'en' || this.accommodationForm.controls.hotelDescription.value === ''"
                    (click)="translateHotelDescription(this.accommodationForm.controls.hotelDescription.value)">
              <span nz-icon nzType="plus"></span>
              {{ 'itineraries.accommodation.form.translate' | transloco }}
            </button>
          </div>
        </div>
      </div>
      <nz-divider></nz-divider>

      <nz-card class="mb-4 hover:cursor-pointer select-none"
               (click)="this.toggleRoomBreakdown = !this.toggleRoomBreakdown">
        <div class="flex flex-row items-center justify-between">
          <div>
            <h6 class="font-normal text-lg">{{ 'itineraries.accommodation.form.roomSection' | transloco }}</h6>
          </div>
          <div class="flex flex-row items-center gap-2">
            <span
              *ngIf="getTotalCost() !== 0"
              class="font-normal text-lg">
              {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
              {{ getTotalCost() | number:'1.2-2' }}
            </span>
            <span nz-icon [nzType]="this.toggleRoomBreakdown ? 'up' : 'down'" nzTheme="outline"></span>
          </div>
        </div>

        <div *ngIf="this.toggleRoomBreakdown" (click)="$event.stopPropagation()">
          <nz-divider></nz-divider>
          <div class="flex flex-row">

              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.adults }} {{ 'itineraries.accommodation.form.adults' | transloco }}
              </nz-tag
              >
              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.children }} {{ 'itineraries.accommodation.form.children' | transloco }}
              </nz-tag
              >
              <nz-tag [nzColor]="'purple'"
              >{{ this.itinerary?.tour.pax.infants }} {{ 'itineraries.accommodation.form.infants' | transloco }}
              </nz-tag
              >
          </div>
          <div class="mt-9 mb-5 flex flex-row justify-between">
            <div class="mb-4 flex flex-row items-center gap-4">
              <div class="flex flex-row items-center gap-1">
              <span class="font-medium">{{ 'itineraries.accommodation.form.vat' | transloco }}</span>
                <lucide-icon
                  name="info"
                  class="icon-size cursor-pointer text-purple-600"
                  nz-tooltip
                  [nzTooltipTitle]="'itineraries.accommodation.form.vatTooltip' | transloco"
                ></lucide-icon>
              </div>
              <nz-radio-group formControlName="isTaxed" class="flex flex-row gap-4">
                <label nz-radio [nzValue]="true">{{ 'itineraries.accommodation.form.included' | transloco }}</label>
                <label nz-radio [nzValue]="false">{{ 'itineraries.accommodation.form.excluded' | transloco }}</label>
              </nz-radio-group>
            </div>
            <nz-form-item class="mb-3 flex flex-row justify-end gap-2" style="flex-direction: row">
              <nz-form-label class="mt-2" nzFor="costingCurrency">{{ 'itineraries.accommodation.form.costingCurrency' | transloco }} :</nz-form-label>
              <div class="w-24">
                <nz-select [(ngModel)]="this.isPrimaryCurrency" [ngModelOptions]="{standalone: true}" (ngModelChange)="fetchContracts()">
                  <nz-option
                    *ngFor="let lang of this.currencies"
                    [nzValue]="lang?.value"
                    [nzLabel]="lang?.label"></nz-option>
                </nz-select>
              </div>
            </nz-form-item>
          </div>
          <div>
            <!-- Header row -->
            <div class="grid grid-cols-12 gap-4 mb-2 items-end">
              <div class="col-span-2 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.roomCategory' | transloco }}
                  <span class="text-red-500">*</span>
                </span>
              </div>
              <div class="col-span-2 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.roomType' | transloco }}
                  <span class="text-red-500">*</span>
                </span>
              </div>
              <div class="col-span-2 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.mealType' | transloco }}
                  <span class="text-red-500">*</span>
                </span>
              </div>
              <div class="col-span-2 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.roomRate' | transloco }}
                  ( {{this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency}} )
                </span>
              </div>
              <div class="col-span-1 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.noOfRooms' | transloco }}
                </span>
              </div>
              <div class="col-span-2 flex items-end">
                <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                  {{ 'itineraries.accommodation.form.cost' | transloco }}
                  ( {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }} )
                </span>
              </div>
              <div class="col-span-1"></div>
            </div>

            <!-- Data rows -->
            <div formArrayName="rooms" *ngFor="
                      let room of getRooms().controls;
                      let index = index">
              <div [formGroupName]="index" class="grid grid-cols-12 gap-4">
                <div class="col-span-2">
                  <nz-form-item class="flex justify-start mb-0">
                    <nz-form-control [nzErrorTip]="roomCategoryCheck">
                      <nz-select
                        nzShowSearch
                        [nzShowArrow]="false"
                        formControlName="roomCategory"
                        [nzPlaceHolder]="'itineraries.accommodation.form.searchRoomCategory' | transloco"
                        [nzBackdrop]="true"
                        [nzDropdownRender]="renderCatoTemplate">

                        <nz-option *ngFor="let types of listOfRoomCatoOptions" [nzValue]="types.value"
                                   [nzLabel]="types.label"></nz-option>
                      </nz-select>
                      <ng-template #renderCatoTemplate>
                        <nz-divider></nz-divider>
                        <div class="container">
                          <input type="text" [placeholder]="'itineraries.accommodation.form.name' | transloco" nz-input #inputCatoElement />
                          <a class="add-item"
                             [style.pointer-events]="(!inputCatoElement.value) ? 'none' : 'auto'"
                             [style.opacity]="(!inputCatoElement.value) ? '0.5' : '1'"
                             [class.disabled]="!inputCatoElement.value"
                             (click)="addCatoItem(inputCatoElement)">
                            <nz-icon nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                            {{ 'itineraries.accommodation.form.addItem' | transloco }}
                          </a>
                        </div>
                      </ng-template>
                    </nz-form-control>
                    <ng-template #roomCategoryCheck>
                      <span *ngIf="formErrors.rooms.roomCategory.required">
                        {{ 'itineraries.accommodation.form.errors.roomCategoryRequired' | transloco }}
                      </span>
                    </ng-template>
                  </nz-form-item>
                </div>

                <div class="col-span-2">
                  <nz-form-item class="flex justify-start mb-0">
                    <nz-form-control [nzErrorTip]="roomTypeCheck">
                      <nz-select
                        nzShowSearch
                        [nzShowArrow]="false"
                        formControlName="roomType"
                        [nzPlaceHolder]="'itineraries.accommodation.form.searchRoomType' | transloco"
                        [nzDropdownRender]="renderRoomTypeTemplate"
                        [nzBackdrop]="true">

                        <nz-option *ngFor="let types of listOfRoomTypeOptions" [nzValue]="types.value"
                                   [nzLabel]="types.label"></nz-option>
                      </nz-select>
                      <ng-template #renderRoomTypeTemplate>
                        <nz-divider></nz-divider>
                        <div class="container">
                          <input type="text" class="mb-1.5" [placeholder]="'itineraries.accommodation.form.name' | transloco" nz-input #inputRoomTypeElement />
                          <a class="add-item"
                             (click)="addRoomTypeItem(inputRoomTypeElement)"
                             [style.pointer-events]="(!inputRoomTypeElement.value) ? 'none' : 'auto'"
                             [style.opacity]="(!inputRoomTypeElement.value) ? '0.5' : '1'"
                             [class.disabled]="!inputRoomTypeElement.value">
                            <nz-icon nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                            {{ 'itineraries.accommodation.form.addItem' | transloco }}
                          </a>
                        </div>
                      </ng-template>
                    </nz-form-control>
                    <ng-template #roomTypeCheck>
                <span *ngIf="formErrors.rooms.roomType.required">
                  {{ 'itineraries.accommodation.form.errors.roomTypeRequired' | transloco }}
                </span>
                    </ng-template>
                  </nz-form-item>
                </div>

                <div class="col-span-2">
                  <nz-form-item class="mb-0">
                    <nz-form-control [nzErrorTip]="mealTypeCheck">
                      <nz-select
                        nzShowSearch
                        [nzShowArrow]="false"
                        formControlName="mealType"
                        [nzPlaceHolder]="'itineraries.accommodation.form.searchMealPlan' | transloco"
                        [nzBackdrop]="true"
                        [nzDropdownRender]="renderMealTypeTemplate">
                        <nz-option *ngFor="let meals of listOfMealTypeOptions" [nzValue]="meals.value"
                                   [nzLabel]="meals.label"></nz-option>
                      </nz-select>
                      <ng-template #renderMealTypeTemplate>
                        <nz-divider></nz-divider>
                        <div class="container">
                          <input type="text" [placeholder]="'itineraries.accommodation.form.name' | transloco" nz-input #inputMealTypeElement />
                          <a class="add-item"
                             [style.pointer-events]="(!inputMealTypeElement.value) ? 'none' : 'auto'"
                             [style.opacity]="(!inputMealTypeElement.value) ? '0.5' : '1'"
                             [class.disabled]="!inputMealTypeElement.value"
                             (click)="addMealTypeItem(inputMealTypeElement)">
                            <nz-icon nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                            {{ 'itineraries.accommodation.form.addItem' | transloco }}
                          </a>
                        </div>
                      </ng-template>
                    </nz-form-control>

                    <ng-template #mealTypeCheck>
                      <span *ngIf="formErrors.rooms.mealType.required">
                        {{ 'itineraries.accommodation.form.errors.mealTypeRequired' | transloco }}
                      </span>
                    </ng-template>
                  </nz-form-item>
                </div>

                <div class="col-span-2">
                  <nz-form-item class="mb-0">
                    <nz-form-control [nzErrorTip]="roomRateCheck">
                      <nz-input-group nzSearch class="py-0">
                        <nz-input-number
                         [nzFormatter]="formatter"
                         [nzParser]="parser"
                         [nzPrecision]="2"
                         class="w-full room-rate-input"
                         [nzMin]="0"
                         [nzPlaceHolder]="'itineraries.accommodation.form.amount' | transloco"
                         formControlName="roomRate"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                    <ng-template #roomRateCheck>
                <span *ngIf="formErrors.roomRate.required">
                  {{ 'itineraries.accommodation.form.errors.roomRateRequired' | transloco }}
                </span>

                    </ng-template>
                  </nz-form-item>
                </div>

                <div class="col-span-1">
                  <nz-form-item class="mb-0">
                    <nz-form-control>
                        <input
                          nz-input
                          class="w-full"
                          type="number"
                          [attr.placeholder]="'itineraries.accommodation.form.amount' | transloco"
                          formControlName="noOfRooms"/>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="col-span-2">
                  <nz-form-item class="mb-0">
                    <p class="font-semibold flex justify-center items-center gap-1">
                      {{
                        (accommodationForm.get('rooms').at(index).value?.cost ?? 0)
                          | number:'1.2-2'
                      }}
                      <lucide-icon
                        name="info"
                        class="icon-size cursor-pointer text-purple-600"
                        nz-tooltip
                        nzTooltipColor="white"
                        [nzTooltipTitle]="costTooltip">
                      </lucide-icon>
                      <ng-template #costTooltip>
                        <div class="p-2 min-w-56">
                          <p class="font-bold text-gray-800 mb-3">{{ 'itineraries.accommodation.form.costBreakdown' | transloco }}</p>
                          <div class="flex justify-between mb-2">
                            <span class="text-gray-600">{{ 'itineraries.accommodation.form.baseRate' | transloco }}</span>
                            <span class="text-gray-800">
                              {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                              {{ getRoomCostBreakdown(index).baseRate | number:'1.2-2' }}
                            </span>
                          </div>
                          <div class="flex justify-between mb-2" *ngIf="accommodationForm.get('isTaxed').value === true">
                            <span class="text-gray-600">{{ 'itineraries.accommodation.form.vatPercentage' | transloco }}</span>
                            <span class="text-gray-800">{{ vatPercentage ?? 0 }}%</span>
                          </div>
                          <div class="flex justify-between">
                            <span class="text-gray-600">{{ 'itineraries.accommodation.form.totalCost' | transloco }}</span>
                            <span class="text-gray-800">
                              {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                              {{ getRoomCostBreakdown(index).total | number:'1.2-2' }}
                            </span>
                          </div>
                        </div>
                      </ng-template>
                    </p>

                  </nz-form-item>
                </div>

                <div class="col-span-1 flex justify-center items-center">
                  <button nz-button nzDanger nzType="default"
                          nz-popconfirm
                          [nzPopconfirmTitle]="'itineraries.accommodation.form.deleteRoomConfirm' | transloco"
                          nzPopconfirmPlacement="bottom"
                          [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                          [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                          (nzOnConfirm)="this.removeRoom(index)"
                          (nzOnCancel)="cancel()">
                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                  </button>
                </div>
                <div class='col-span-10 flex flex-wrap gap-x-2'>
                  <div class= 'mt-2 mb-5' *ngFor="let contract of getMatchingContracts(index)">
                    <nz-tag nzColor="purple" class=" flex flex-row gap-2 items-center">
                        <span class="cursor-pointer" (click)="setRoomRate(index, contract.baseRate)"> {{ contract.baseRate | number:'1.2-2' }} </span>
                        <lucide-icon *ngIf="contract.attachments.length > 0" name="link" (click)="onDownloadAttachment(contract.attachments[0])" class="icon-size cursor-pointer"></lucide-icon>
                        <lucide-icon nz-tooltip [nzTooltipTitle]="contract.name" name="info" class="icon-size cursor-pointer"></lucide-icon>
                    </nz-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.getRoomsLength() === 0">
            <p class="flex justify-center">{{ 'itineraries.accommodation.form.noRoomsFound' | transloco }}</p>
          </div>

              <div class="flex justify-end">
                <button
                  nz-button
                  nzType="default"
                  (click)="addRoom('', '','', 1,0, 0)">
                  {{ 'itineraries.accommodation.form.addRoom' | transloco }}
                </button>
              </div>
              <nz-divider></nz-divider>
              <div class="mt-4">
                <div class="flex items-center  mb-2">
                  <span class="font-medium">{{ 'itineraries.accommodation.form.extraCosts' | transloco }}</span>
                </div>
                <div formArrayName="extraCost">
                  <div
                    *ngFor="let item of getExtraCosts().controls; let i = index"
                    [formGroupName]="i"
                    class="grid grid-cols-12 gap-3 mb-3 items-end">
                    <div class="col-span-6">
                      <nz-form-item class="mb-0">
                        <nz-form-label *ngIf="i === 0" nzFor="name">{{ 'itineraries.accommodation.form.name' | transloco }}</nz-form-label>
                        <nz-form-control>
                          <input nz-input formControlName="name" [placeholder]="'itineraries.accommodation.form.extraCostName' | transloco" />
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div class="col-span-3">
                      <nz-form-item class="mb-0">
                        <nz-form-label *ngIf="i === 0" nzFor="baseRate">
                          {{ 'itineraries.accommodation.form.baseRate' | transloco }} ( {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }} )
                        </nz-form-label>
                        <nz-form-control>
                          <nz-input-number
                            class="w-full"
                            [nzFormatter]="formatter"
                            [nzParser]="parser"
                            [nzPrecision]="2"
                            [nzMin]="0"
                            [nzPlaceHolder]="'itineraries.accommodation.form.amount' | transloco"
                            formControlName="baseRate">
                          </nz-input-number>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div class="col-span-2">
                      <nz-form-item class="mb-0">
                        <nz-form-label *ngIf="i === 0" nzFor="cost">
                          {{ 'itineraries.accommodation.form.cost' | transloco }} ( {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }} )
                        </nz-form-label>
                        <nz-form-control>
                          <p class="font-semibold flex justify-center items-center gap-1">
                            {{
                              (getExtraCosts().at(i).get('cost')?.value ?? 0)
                                | number:'1.2-2'
                            }}
                            <lucide-icon
                              name="info"
                              class="icon-size cursor-pointer text-purple-600"
                              nz-tooltip
                              nzTooltipColor="white"
                              [nzTooltipTitle]="extraCostTooltip">
                            </lucide-icon>
                            <ng-template #extraCostTooltip>
                              <div class="p-2 min-w-56">
                                <p class="font-bold text-gray-800 mb-3">{{ 'itineraries.accommodation.form.costBreakdown' | transloco }}</p>
                                <div class="flex justify-between mb-2">
                                  <span class="text-gray-600">{{ 'itineraries.accommodation.form.baseRate' | transloco }}</span>
                                  <span class="text-gray-800">
                                    {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                                    {{ getExtraCostBreakdown(i).baseRate | number:'1.2-2' }}
                                  </span>
                                </div>
                                <div class="flex justify-between mb-2" *ngIf="accommodationForm.get('isTaxed').value === true">
                                  <span class="text-gray-600">{{ 'itineraries.accommodation.form.vatPercentage' | transloco }}</span>
                                  <span class="text-gray-800">{{ vatPercentage ?? 0 }}%</span>
                                </div>
                                <div class="flex justify-between">
                                  <span class="text-gray-600">{{ 'itineraries.accommodation.form.totalCost' | transloco }}</span>
                                  <span class="text-gray-800">
                                    {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }}
                                    {{ getExtraCostBreakdown(i).total | number:'1.2-2' }}
                                  </span>
                                </div>
                              </div>
                            </ng-template>
                          </p>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div class="col-span-1 flex justify-center" [ngClass]="i === 0 ? 'items-end' : ''">
                      <button nz-button nzDanger nzType="default" type="button" (click)="removeExtraCost(i)">
                        <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex justify-end my-4">
                  <button nz-button nzType="default" type="button" class="flex items-center gap-2" (click)="addExtraCost()">
                    <lucide-icon name="plus" class="icon-size"></lucide-icon> {{ 'itineraries.accommodation.form.addExtraCost' | transloco }}
                  </button>
                </div>
                <div *ngIf="getExtraCosts().length === 0">
                  <p class="flex justify-center">{{ 'itineraries.accommodation.form.noExtraCostsAdded' | transloco }}</p>
                </div>
              </div>

              <nz-divider></nz-divider>

              <div class="grid grid-cols-3 gap-5">
                <!-- <div>
                  <nz-form-item>
                    <nz-form-label nzFor="perChildSupplement">Per Child Supplement</nz-form-label>
                    <nz-form-control [nzErrorTip]="perChildSupplementCheck">
                      <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          class="w-full border-none"
                          [nzMin]="0"
                          nzPlaceHolder="Amount"
                          formControlName="perChildSupplement"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                    <ng-template #perChildSupplementCheck>
                      <span *ngIf="formErrors.perChildSupplement.required">
                        Per Child Supplement is required
                      </span>
                    </ng-template>
                  </nz-form-item>
                </div> -->

                <!-- <div>
                  <nz-form-item>
                    <nz-form-label nzFor="perInfantFee">Per Infant Fee</nz-form-label>
                    <nz-form-control [nzErrorTip]="perInfantFeeCheck">
                      <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          class="w-full border-none"
                          [nzMin]="0"
                          nzPlaceHolder="Amount"
                          formControlName="perInfantFee"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                    <ng-template #perInfantFeeCheck>
                      <span *ngIf="formErrors.perInfantFee.required">
                        Per Infant Fee is required
                      </span>
                    </ng-template>
                  </nz-form-item>
                </div> -->

                <div class="col-span-3">
                  <div class="flex justify-between items-center bg-base-200 p-4">
                    <h6 class="font-semibold">{{ 'itineraries.accommodation.form.totalCost' | transloco }} ( {{ this.isPrimaryCurrency ? this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency }} )</h6>
                    <h6 class="font-bold">{{ this.getTotalCost() | number:'1.2-2' }}</h6>
                  </div>
                </div>
              </div>

            </div>
          </nz-card>
      <nz-card class="mb-4 hover:cursor-pointer select-none"
               (click)="this.toggleNotes = !this.toggleNotes">
        <div class="flex flex-row items-center justify-between">
          <div>
            <h6 class="font-normal text-lg">{{ 'itineraries.accommodation.form.notes' | transloco }}</h6>
          </div>
          <div>
            <span nz-icon [nzType]="this.toggleNotes ? 'up' : 'down'" nzTheme="outline"></span>
          </div>
        </div>
        <div *ngIf="this.toggleNotes" (click)="$event.stopPropagation()">
          <nz-divider></nz-divider>
          <nz-form-item>
            <nz-form-control>
              <textarea
                class="select-text"
                [placeholder]="'itineraries.accommodation.form.addNotesOptional' | transloco"
                nz-input
                formControlName="notes"
                rows="6"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </nz-card>
    </form>
  </div>
</div>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.accommodation.form.close' | transloco }}</button>
  <button *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.NEW" nz-button nzType="primary"
          (click)="addAccommodation()"
          [nzLoading]="this.isButtonLoading"
          [disabled]="!this.accommodationForm.valid || this.googlePlaceDetails === undefined "
  >{{ 'itineraries.accommodation.form.add' | transloco }}
  </button>
  <button *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT" nz-button nzType="primary"
          (click)="editAccommodation()"
          [nzLoading]="this.isButtonLoading"
          [disabled]="!this.accommodationForm.valid"
  >{{ 'itineraries.accommodation.form.edit' | transloco }}
  </button>
</div>
</nz-spin>
